import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import _isArray from "lodash/isArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { Children, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigationControls } from '../NavigationContext';
import MenuList from './MenuList';
import Content from './Content';
import { mainContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var SideNav = function SideNav(_ref) {
  var _ref$children = _ref.children,
      initChildren = _ref$children === void 0 ? [] : _ref$children,
      _ref$routes = _ref.routes,
      routes = _ref$routes === void 0 ? [] : _ref$routes,
      notFoundComponent = _ref.notFoundComponent,
      homeRoute = _ref.homeRoute,
      topNavigation = _ref.topNavigation,
      footer = _ref.footer,
      _ref$closeBreakPoint = _ref.closeBreakPoint,
      closeBreakPoint = _ref$closeBreakPoint === void 0 ? 1200 : _ref$closeBreakPoint;
  var children = Children.toArray(initChildren).filter(Boolean);

  var _useNavigationControl = useNavigationControls(),
      changeAllRoutes = _useNavigationControl.changeAllRoutes;

  useEffect(function () {
    extractAllRoutes();
  }, []);

  var extractAllRoutes = function extractAllRoutes() {
    var allRoutesList = _toConsumableArray(routes);

    var extractNestedRoutes = function extractNestedRoutes(elements) {
      return elements.forEach(function (el) {
        var _el$props;

        var menu = _objectSpread({}, (_el$props = el === null || el === void 0 ? void 0 : el.props) !== null && _el$props !== void 0 ? _el$props : el);

        if (_isArray(menu === null || menu === void 0 ? void 0 : menu.subMenus)) {
          var _menu$subMenus$;

          menu.redirectsTo = (_menu$subMenus$ = menu.subMenus[0]) === null || _menu$subMenus$ === void 0 ? void 0 : _menu$subMenus$.url;
          allRoutesList.push(menu);
          return extractNestedRoutes(menu.subMenus);
        }

        return allRoutesList.push(menu);
      });
    };

    extractNestedRoutes(children);
    changeAllRoutes(allRoutesList !== null && allRoutesList !== void 0 ? allRoutesList : []);
  };

  return ___EmotionJSX("main", {
    css: mainContainer
  }, ___EmotionJSX(MenuList, {
    sideNavChildrens: children,
    footer: footer,
    homeRoute: homeRoute,
    closeBreakPoint: closeBreakPoint
  }), ___EmotionJSX(Content, {
    notFoundComponent: notFoundComponent,
    homeRoute: homeRoute,
    topNavigation: topNavigation
  }));
};

SideNav.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  routes: PropTypes.array,
  notFoundComponent: PropTypes.func,
  homeRoute: PropTypes.string,
  topNavigation: PropTypes.any,
  footer: PropTypes.any,
  closeBreakPoint: PropTypes.number
};
export default SideNav;